import React, { useContext } from "react";
import classes from "./Footer.module.css";
import { ThemeContext } from "../../ThemeProvider";

const Footer = () => {
  const { dark } = useContext(ThemeContext);

  return (
    <footer
      className={
        dark ? `${classes.footer} ${classes.footer__dark}` : classes.footer
      }
    >
      <p>
        Design inspired from{" "}
        <a href="https://brittanychiang.com/" target="_blank" rel="noreferrer">
          brittanychiang.com(v4)
        </a>{" "}
      </p>
      <p>
        Built by{" "}
        <a
          href="https://github.com/partharoyy"
          target="_blank"
          rel="noreferrer"
        >
          Partha Roy
        </a>
      </p>
    </footer>
  );
};

export default Footer;
